import { on } from "delegated-events";
import { gsap } from "gsap";

const siteMenuTrigger = document.querySelector(".site-menu-trigger");
const siteMenu = document.querySelector(".site-menu");

const openMenu = () => {
  siteMenuTrigger.setAttribute("aria-label", "Close main menu");
  siteMenuTrigger.setAttribute("aria-expanded", "true");
  siteMenu.setAttribute("aria-hidden", "false");
  document.documentElement.classList.add("js-menu-active");

  if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
    gsap.set(".site-menu-wrapper", { x: "100%" });
    gsap.set(".site-menu-close", { opacity: 0 });
    gsap.set(".site-menu-logo", { opacity: 0 });
    gsap.set(".site-header-actions-mobile .btn, .site-menu-wrapper li", { y: "60%", opacity: 0 });

    const timeline = gsap.timeline();

    timeline.to(".site-menu-wrapper", { x: 0, duration: 0.5, ease: "expoScale(0.5, 7, none)" });
    timeline.to(
      ".site-header-actions-mobile .btn, .site-menu-wrapper li",
      {
        y: 0,
        opacity: 1,
        duration: 0.4,
        stagger: 0.05,
        ease: "expoScale(0.5, 7, none)",
      },
      "<50%",
    );
    timeline.to(
      ".site-menu-close",
      {
        opacity: 1,
        duration: 0.6,
        ease: "expoScale(0.5, 7, none)",
      },
      "<",
    );
    timeline.to(
      ".site-menu-logo",
      {
        opacity: 1,
        duration: 0.6,
        ease: "expoScale(0.5, 7, none)",
      },
      "<",
    );
    timeline.to(
      ".site-menu-wrapper",
      {
        filter: "drop-shadow(0px 0px 100px rgba(44, 101, 216, 1))",
        duration: 1,
        ease: "expoScale(0.5, 7, none)",
      },
      "<",
    );
  }
};

const closeMenu = async () => {
  siteMenuTrigger.setAttribute("aria-label", "Open main menu");
  siteMenuTrigger.setAttribute("aria-expanded", "false");
  siteMenuTrigger.classList.add("pointer-events-none");
  siteMenu.setAttribute("aria-hidden", "true");

  if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
    const timeline = gsap.timeline({
      paused: true,
    });

    timeline.to(".site-menu-wrapper", {
      filter: "drop-shadow(0px 0px 100px rgba(44, 101, 216, 0))",
      duration: 0.3,
      ease: "expoScale(0.5, 7, none)",
    });

    timeline.to(
      ".site-header-actions-mobile .btn, .site-menu-wrapper li",
      {
        y: "60%",
        opacity: 0,
        duration: 0.25,
        ease: "expoScale(0.5, 7, none)",
      },
      "<",
    );

    timeline.to(
      ".site-menu-bottom-actions-border",
      {
        opacity: 0,
        duration: 0.3,
        ease: "expoScale(0.5, 7, none)",
      },
      "<",
    );

    timeline.to(
      ".site-menu-close",
      {
        opacity: 0,
        duration: 0.3,
        ease: "expoScale(0.5, 7, none)",
      },
      "<",
    );

    timeline.to(".site-menu-wrapper", { x: "100%", duration: 0.4, ease: "expoScale(0.5, 7, none)" });

    await timeline.play();
  }

  document.documentElement.classList.remove("js-menu-active");
  siteMenuTrigger.classList.remove("pointer-events-none");
};

export default {
  init: () => {
    on("click", ".site-menu-trigger", (e) => {
      const trigger = e.currentTarget;

      if (trigger.getAttribute("aria-expanded") === "true") {
        closeMenu();
      } else {
        openMenu();
      }
    });

    on("click", ".site-menu", (e) => {
      if (!e.target.closest(".site-menu-wrapper")) {
        closeMenu();
      }
    });
  },
};
